import { Component, inject, signal } from '@angular/core';
import { SharedUiModule } from '@pf/shared-ui';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { ProfileProvider } from '@pf/shared-common';
import { UserAccountType } from '@pf/shared-services';

@Component({
    standalone: true,
    selector: 'cpw-error-drawer',
    template: `
        <pf-text type="danger">{{ data.error }}</pf-text>

        @if (data.expectedInput) {
            <span>
                Expected:
                <pf-chip
                    pfStatus="primary"
                    (click)="copyExpected()"
                    [style.cursor]="isAdmin ? 'pointer' : 'default'"
                    >{{ copied() ? 'Copied!' : data.expectedInput }}</pf-chip
                >
            </span>
        }
        <span>
            Provided:
            <pf-chip pfStatus="danger">{{ data.providedInput }}</pf-chip>
        </span>
        <pf-button buttonType="submit" block (click)="tryAgain()"
            >Try Again</pf-button
        >
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                gap: var(--pf-gap);

                span {
                    display: flex;
                    gap: var(--pf-gap);
                }

                pf-button {
                    margin-top: var(--pf-section-gap);
                }
            }
        `,
    ],
    imports: [SharedUiModule],
})
export class CpwErrorDrawerComponent {
    data: {
        error: string;
        providedInput: string;
        expectedInput: string | undefined;
    } = inject(NZ_DRAWER_DATA);
    drawerRef = inject(NzDrawerRef);
    private readonly profileProvider = inject(ProfileProvider);

    isAdmin =
        this.profileProvider.profile.userGroupType?.toLowerCase() ===
        UserAccountType.Administrator;

    copied = signal(false);

    copyExpected() {
        if (!this.isAdmin || !this.data.expectedInput) return;
        navigator.clipboard.writeText(this.data.expectedInput).then(() => {
            this.copied.set(true);
            setTimeout(() => this.copied.set(false), 1500);
        });
    }

    tryAgain() {
        this.drawerRef.close();
    }
}
